module.exports = __webpack_public_path__ + "static/media/2013 Italy.4995f8bf.jpg";